import { sendAnalytics } from 'shared/utils/analytics';

export const trackAllFactoidsOpen = () => sendAnalytics({ action: 'Click', label: 'all_parameters' });
